<div class="form-wrap help-options-container">
    <ua-alert-msg *ngIf="showAlertMessage" [mode]="alertMsg.mode" [message]="alertMsg.message"></ua-alert-msg>
    <h4 aria-level="1" class="title">{{pageConstants[title]}}</h4>
    <div class="btn-wrap helpOptions" *ngFor="let option of helpOptions">
        <button class="btn col-sm-8 col-md-6 col-lg-4 {{option?.label}}" [ngClass]= 'option?.styleClass' (click)="onOptionSelect(option.value)">
            <div class="btn-content">
                <div class="icon-wrap">
                    <img alt="" src="./../../../assets/{{option.icon}}"/>
                </div>
                <span class="btn-text">{{ pageConstants[option.label] }}</span>
            </div>
        </button>
    </div>
    <div class="link-text-wrap" *ngIf="secondaryOption.display">
        <button class="link-text unstyle-button" (click)="onOptionSelect(secondaryOption.value)">
            {{pageConstants[secondaryOption.label]}}
        </button>
    </div>
    <ua-boarding-pass-viewer *ngIf="showBoardingPass" (modalDismiss) = "closeModal()"></ua-boarding-pass-viewer>
    <ua-send-boardingpass-modal *ngIf="showSendBoardingPass" (modalDismiss) = "closeModal($event)"></ua-send-boardingpass-modal>
</div>
